module.exports = __webpack_public_path__ + "07bc3a28ae4c7ca31f4665d06aad80b5.svg";